/* eslint-disable react/no-this-in-sfc */
import React from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import Carrousel from "../../components/Carrousel";
import MainLayout from "../../layout/MainLayout";
import styled from "styled-components";
import Missionyvision from "../AboutEnterprise/Mision";
import { Link } from "react-router-dom";
import { ExternalLink } from "react-external-link";
import CardService from "../../components/cards/CardService";

const Hero = styled.section`
  display: flex;
  height: 80vh;
  background-color: ${(props) => props.theme.colors.primary};
  color: #ffffff;
  @media (max-width: 768px) {
    height: auto; /* Se ajusta la altura automáticamente en pantallas pequeñas */
  }
`;

const HeroContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 50px;
  align-items: flex-start;
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: 700;
`;

const Subtitle = styled.h2`
  font-size: 24px;
  font-weight: 300;
  margin-top: 10px;
`;

const Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const HeroButton = styled.a`
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  color: ${({ primary }) => (primary ? "#00274d" : "#ffffff")};
  background-color: ${({ primary }) => (primary ? "#ffbf00" : "transparent")};
  border: 2px solid ${({ primary }) => (primary ? "#ffbf00" : "#ffffff")};
  border-radius: 5px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ primary }) => (primary ? "#d9a800" : "#ffffff")};
    color: ${({ primary }) => (primary ? "#ffffff" : "#00274d")};
  }

  @media (max-width: 480px) {
    font-size: 0.85rem; /* Más pequeño en pantallas muy pequeñas */
    padding: 8px 6vw; /* Más espacio lateral */
    flex-direction: column;
  }
`;

const TitleItems = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
  text-align: center;
  font: normal normal bold 60px / 53px;
`;

//const TitleLink = styled.h2`
//font-size: 1rem;
/*margin-bottom: 10px;*/
//font-weight: bold;
//color: #f7bc0c;
//text-align: center;
/*font: normal normal bold 60px / 53px;*/
//`;
//*/}
const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;

// Styled components
const Section = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f9f9f9;
  @media (max-width: 768px) {
    height: auto; // Ajustamos el alto en pantallas pequeñas
    padding: 16px 0;
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 50vh; // Ajustamos el alto en móviles
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
`;

const BeforeImage = styled(Image)`
  clip-path: ${({ dividerPosition }) =>
    `inset(0 ${100 - dividerPosition}% 0 0)`};
  transition: clip-path 0.3s ease-in-out;
`;

const AfterImage = styled(Image)`
  clip-path: ${({ dividerPosition }) => `inset(0 0 0 ${dividerPosition}%)`};
  transition: clip-path 0.3s ease-in-out;
`;
const Divider2 = styled.div`
  position: absolute;
  top: 0;
  left: ${({ dividerPosition }) => `${dividerPosition}%`};
  width: 5px;
  height: 100%;
  background-color: white;
  cursor: ew-resize;
  z-index: 10;
  transition: left 0.3s ease-in-out;
`;

// Estilos para el enlace
const LinkNew = styled(Link)`
  text-decoration: none;
  &:hover {
    color: #fff;
  }
`;

const TitleLink = styled.h2`
  font-size: 1rem;
  font-weight: bold;
  color: #f7bc0c;
  text-align: center;
`;

// Contenedor de las tarjetas con diseño flex
const ContainerCards = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 16px;

  // Media query para pantallas más pequeñas (mobile)
  @media (max-width: 768px) {
    flex-direction: column; // Cambiar a columna en dispositivos móviles
    align-items: center; // Centrar los elementos
  }
`;

// Estilos para las tarjetas
const Card = styled.div`
  width: 100%;
  max-width: 350px; // Máxima anchura para las tarjetas

  // Media query para pantallas más pequeñas
  @media (max-width: 768px) {
    width: 80%; // Ocupa más espacio en móvil
    margin-bottom: 16px;
  }
`;

// Estilos para las imágenes dentro de las tarjetas
const ImageCard = styled.img`
  width: 100%;
  height: 400px;
  border-radius: 8px;
`;

const banners = [
  { link: "./img/banners/carrousel.webp" },
  { link: "./img/banners/carrousel1.webp" },
  { link: "./img/banners/carrousel2.webp" },
];
const ServicesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #f9f9f9;
  padding: 40px;
`;

const HomePage = () => {
  const [dividerPosition, setDividerPosition] = React.useState(50);

  const handleMouseMove = (e) => {
    const container = e.target.closest("[data-container]");
    const bounds = container.getBoundingClientRect();
    const position = ((e.clientX - bounds.left) / bounds.width) * 100;
    setDividerPosition(Math.max(0, Math.min(position, 100))); // Clamps between 0 and 100
  };

  return (
    <MainLayout category="TODAS">
      <Hero>
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0 m-0 d-flex">
          <HeroContent>
            <Title>We build your dreams</Title>
            <Subtitle>With quality and commitment.</Subtitle>
            <Buttons>
              <HeroButton
                href={"https://api.whatsapp.com/send?phone=16314885832"}
                primary
              >
                Contact
              </HeroButton>{" "}
              <HeroButton href="/portfolio/gallery">
                Explore Our Projects
              </HeroButton>
            </Buttons>
          </HeroContent>
        </div>
        <div className="col-12 col-md-6 col-lg-6 p-0 m-0">
          <Carrousel banners={banners} />
        </div>
      </Hero>

      {/*<div
        className="col-12 col-sm-12 col-md-6 col-lg-6 p-0 m-0 mt-3 ps-3 pe-3 d-block d-md-none"
        style={{ height: "50vh" }}
      >
        <Carrousel banners={banners} />
      </div>*/}

      <div className="row pt-4" style={{ "background-color": "#f9f9f9" }}>
        <div className="col-12 col-lg-12 pt-4 mt-4">
          <div className="col-12 col-md-12 display-flex justify-content-center pt-4 mt-4">
            <TitleItems>About US</TitleItems>
            <Divider />
            <Missionyvision />
          </div>
        </div>
      </div>

      <div className="row pt-4 mt-4">
        <div className="col-12 col-lg-12 pt-4 mt-4 pb-4 mb-4">
          <video
            controls
            className="object-fit-contain d-block m-auto"
            autoplay="autoplay"
            muted
            width="100%"
            loop
            style={{
              height: "auto", // Aseguramos que el video no tenga una altura fija
              maxHeight: "60vh", // Limitamos la altura en dispositivos móviles
            }}
          >
            {/* <source src="/img/360/Video-Coinsa-corto.webm" type="video/mp4" /> */}
            <source src="/video/DGPConstruction.mp4" type="video/mp4" />
            Tu navegador no admite el elemento de video.
          </video>
        </div>
      </div>
      <ServicesContainer>
        <TitleItems>Services</TitleItems>
        <Divider />
        <CardService />
      </ServicesContainer>
      <div className="row pt-4 mb-4" style={{ "background-color": "#f9f9f9" }}>
        <div className="col-12 col-lg-12 pt-4 mt-4">
          <div className="col-12 col-md-12 display-flex justify-content-center pt-4 mt-4"></div>
        </div>
      </div>

      <div
        className="row pt-4 pb-4"
        style={{
          background: "rgb(19,92,160)",
          background:
            "radial-gradient(circle, rgba(19,92,160,1) 0%, rgba(4,28,64,0.7814775568430498) 35%, rgba(74,208,250,1) 100%)",
        }}
      >
        <div className="col-12 col-sm-12 col-md-12 pt-4 mt-4">
          <TitleItems>A Portfolio Of Our Work</TitleItems>
          <Divider />
        </div>
        <ContainerCards>
          <Card>
            <ImageCard src="./img/portfolio/img1.webp" alt="Imagen 1" />
          </Card>
          <Card>
            <ImageCard src="./img/banners/carrousel.webp" alt="Imagen 2" />
          </Card>
          <Card>
            <ImageCard src="./img/portfolio/img4.webp" alt="Imagen 3" />
          </Card>

          {/* Enlace "Ver más" */}
          <div
            style={{ width: "100%", textAlign: "center", marginTop: "16px" }}
          >
            <LinkNew to="/portfolio/gallery">
              <TitleLink>See more</TitleLink>
            </LinkNew>
          </div>
        </ContainerCards>
      </div>
      {/*<div
      className="col-12 col-lg-12 pt-4 pb-4 mb-4"
      style={{ "background-color": "#f9f9f9" }}
    >
      <div className="col-12 display-flex justify-content-center">
        <Values/>
      </div>
    </div>*/}
      <div
        className="row pt-4 pb-4"
        style={{
          "background-color": "#f9f9f9",
        }}
      >
        <div className="col-12 col-sm-12 col-md-12 pt-4 mt-4">
          <TitleItems>Amazing Transformation</TitleItems>
          <Divider />
        </div>
        <Section>
          <Container data-container onMouseMove={handleMouseMove}>
            <BeforeImage
              src="./img/brand/imgT3.webp"
              dividerPosition={dividerPosition}
            />
            <AfterImage
              src="./img/brand/imgT4.webp"
              dividerPosition={dividerPosition}
            />
            <Divider2 dividerPosition={dividerPosition} />
          </Container>
        </Section>
      </div>
    </MainLayout>
  );
};

export default HomePage;
